import { render, staticRenderFns } from "./expositions.vue?vue&type=template&id=3a06b56c&scoped=true&"
import script from "./expositions.vue?vue&type=script&lang=js&"
export * from "./expositions.vue?vue&type=script&lang=js&"
import style0 from "./expositions.vue?vue&type=style&index=0&id=3a06b56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a06b56c",
  null
  
)

export default component.exports